import * as M from "../Model/rentalsModel"
import * as O from "fp-ts/Option"
import * as E from "fp-ts/Either"
import { cmd, http } from "elm-ts"
import { BookingsByMonth, Variant, IO } from "@flypengine/myFlyp-lib"
import { pipe, flow } from "fp-ts/function"
import { API_BASE_URL } from "../../runtimeVariables"
import * as Http from "../../Http"
import { PageStatus } from "../../lib/types"

export const initModel: M.Model = E.left("Not Attempted")
export const initCmd: cmd.Cmd<M.Msg> = cmd.of(M.Msg.init())

export const update: <msg>(
  config: M.Config<msg>
) => (msg: M.Msg) => (model: M.Model) => [M.Model, cmd.Cmd<msg>] =
  config => msg => model =>
    pipe(
      msg,
      Variant.caseOf({
        [M._init]: () => [model, cmd.of(config.dealRentalsMsg())],
        [M._noOp]: () => [model, cmd.none],
        [M._lastFocused]: lastFocused => [
          pipe(
            model,
            E.map(prevModel => ({ ...prevModel, lastFocused }))
          ),
          cmd.none,
        ],
        [M._modalContents]: modalContents => [
          pipe(
            model,
            E.map(prevModel => ({ ...prevModel, modal: modalContents }))
          ),
          pipe(
            modalContents,
            O.match(
              () =>
                pipe(
                  model,
                  E.match(
                    () => cmd.none,
                    prevModel =>
                      pipe(
                        prevModel.lastFocused,
                        O.match(
                          () => cmd.none,
                          lastFocused => {
                            document.getElementById(lastFocused)?.focus()
                            return cmd.none
                          }
                        )
                      )
                  )
                ),
              () => cmd.none
            )
          ),
        ],
        [M._bookingsByMonthReq]: () => [
          pipe(
            model,
            E.map(prevModel => ({
              ...prevModel,
              bookingsByMonth: E.left("Loading"),
            }))
          ),
          pipe(
            http.get(
              `${API_BASE_URL}/myFlyp/rentals/${encodeURI(
                config.propcode
              )}/bookings`,
              flow(
                BookingsByMonth.decode,
                E.mapLeft(IO.validationErrorsToString)
              )
            ),
            Http.sendRequest(config.user)(
              flow(M.Msg.bookingsByMonthRes, config.wrapperMsg)
            )
          ),
        ],
        [M._bookingsByMonthRes]: response => [
          pipe(
            model,
            E.map(prevModel => ({
              ...prevModel,
              bookingsByMonth: pipe(
                response,
                E.mapLeft(() => <PageStatus>"Error")
              ),
            }))
          ),
          cmd.none,
        ],
        [M._faqModal]: newFaqModel => [
          pipe(
            model,
            E.map(prevModel => ({ ...prevModel, faqModel: newFaqModel }))
          ),
          cmd.none,
        ],
      })
    )
